import React, { useState } from "react";

import useStyles from "@hooks/useStyles";
import shortid from "shortid";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import Box from "@material-ui/core/Box";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import Zoom from "@material-ui/core/Zoom";
import Tooltip from "@material-ui/core/Tooltip";
import LocationOnOutlinedIcon from "@material-ui/icons/LocationOnOutlined";
import CallIcon from "@material-ui/icons/Call";
import ScheduleIcon from "@material-ui/icons/Schedule";
import MailOutlineIcon from "@material-ui/icons/MailOutline";

import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import LineBreak from "@components/Global/Custom/Icons/LineBreak";

import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import TwitterIcon from "@material-ui/icons/Twitter";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import YouTubeIcon from "@material-ui/icons/YouTube";
import LogoIcon from "@components/Global/Custom/Logo/LogoIcon";
import GoogleIcon from "@components/Global/Custom/Icons/GoogleIcon";
import YelpIcon from "@components/Global/Custom/Icons/YelpIcon";
import HouzzIcon from "@components/Global/Custom/Icons/HouzzIcon";
import PinterestIcon from "@components/Global/Custom/Icons/PinterestIcon";
import Logo from "@components/Global/Custom/Logo/Logo";

const { BRAND_NAME, SITE_NAME } = process.env;

const WebsiteFooter = () => {
	const classes = useStyles("Website");
	const businessName = "Barton Creek Child Center";
	const logo = "http://www.bartoncreekkids.org/s/misc/logo.jpg";

	const showAddress = true;
	const showPhone = true;
	const showEmail = true;

	const legal = false;

	const [isHovered, setIsHovered] = useState(false);
	const handleMouseEnter = () => setIsHovered(true);
	const handleMouseLeave = () => setIsHovered(false);

	const links = [
		{
			item: "Home",
			link: "/",
		},
		{
			item: "Services",
			link: "/",
		},
		{
			item: "Classes",
			link: "/",
		},
		{
			item: "Memberships",
			link: "/",
		},
		{
			item: "Meet your team",
			link: "/",
		},
		{
			item: "About us",
			link: "/",
		},
		{
			item: "Reviews",
			link: "/",
		},
	];

	const daysOfWeek = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
	const hourSlots = [
		"9 AM – 5 PM",
		"9 AM – 5 PM",
		"9 AM – 5 PM",
		"9 AM – 5 PM",
		"9 AM – 5 PM",
		"Closed",
		"Closed",
	];

	const socialMedia = [
		{
			key: BRAND_NAME,
			label: BRAND_NAME,
			addLabel: `Add ${BRAND_NAME}`,
			link: "/pros/profile/edit-info",
			icon: <LogoIcon width={24} height="100%" filter="grayscale(100%)" />,
		},

		{
			key: "facebook",
			label: "Facebook",
			addLabel: "Add Facebook",
			link: "/pros/profile/edit-info",
			icon: <FacebookIcon />,
		},
		{
			key: "twitter",
			label: "Twitter",
			addLabel: "Add Twitter",
			link: "/pros/profile/edit-info",
			icon: <TwitterIcon />,
		},
		{
			key: "instagram",
			label: "Instagram",
			addLabel: "Add Instagram",
			link: "/pros/profile/edit-info",
			icon: <InstagramIcon />,
		},
		{
			key: "youtube",
			label: "YouTube",
			addLabel: "Add YouTube",
			link: "/pros/profile/edit-info",
			icon: <YouTubeIcon />,
		},
		{
			key: "linkedin",
			label: "LinkedIn",
			addLabel: "Add LinkedIn",
			link: "/pros/profile/edit-info",
			icon: <LinkedInIcon />,
		},
		{
			key: "google",
			label: "Google",
			addLabel: "Add Google",
			link: "/pros/profile/edit-info",
			icon: <GoogleIcon color={false} />,
		},
		{
			key: "yelp",
			label: "Yelp",
			addLabel: "Add Yelp",
			link: "/pros/profile/edit-info",
			icon: <YelpIcon />,
		},
		{
			key: "houzz",
			label: "Houzz",
			addLabel: "Add Houzz",
			link: "/pros/profile/edit-info",
			icon: <HouzzIcon />,
		},
		{
			key: "pinterest",
			label: "Pinterest",
			addLabel: "Add Pinterest",
			link: "/pros/profile/edit-info",
			icon: <PinterestIcon color={false} />,
		},
	];

	return (
		<React.Fragment>
			<Box component={"section"} bgcolor="grey.100" py={20}>
				<Box mx={6}>
					<Container maxWidth={"lg"} disableGutters>
						<Grid container spacing={10} justifyContent="center">
							<Grid item xs={12} sm={6} md={4}>
								<Box
									display={"flex"}
									alignItems={"center"}
									component={"a"}
									href="/"
									alt={businessName}
									aria-label={businessName}
								>
									<Avatar
										alt={"biz name"}
										src={logo}
										classes={{
											img: classes.footerLogo,
											root: classes.footerLogo,
										}}
									/>
								</Box>
								<Box lineHeight={1.5} color={"grey.800"} mt={6}>
									Zen Kidz TX provides yoga and mindfulness classes, workshops,
									and events for kids ages 1 and up in Houston, Texas, at
									schools, private homes, and in our studio in Spring Branch.
								</Box>

								<Box
									display={"flex"}
									alignItems={"center"}
									flexWrap={"wrap"}
									mt={6}
								>
									{socialMedia.map((icon, index) => (
										<Tooltip
											enterDelay={100}
											title={icon.label}
											arrow
											TransitionComponent={Zoom}
											placement={"top"}
											key={shortid.generate()}
										>
											<IconButton href={icon.link} target="_blank">
												{icon.icon}
											</IconButton>
										</Tooltip>
									))}
								</Box>
							</Grid>

							{(showAddress || showPhone || showEmail) && (
								<Grid item xs={12} sm={6} md={3}>
									<Grid container spacing={6}>
										<Grid item xs={12}>
											<Box fontSize={20} fontWeight={600}>
												Contact us
											</Box>
										</Grid>
										{showAddress && (
											<Grid item xs={12}>
												<Box display={"flex"} style={{ gap: 12 }}>
													<LocationOnOutlinedIcon />
													<Box
														display={"flex"}
														flexDirection={"column"}
														style={{ gap: 4 }}
													>
														<Link
															href="directions link"
															className={classes.footerLink}
															color="secondary"
															target="_blank"
														>
															Barton Creed Child Development Center
														</Link>
														<div>51540 Romeo Plank</div>
														<div>Macomb, MI 48042</div>
														<Link
															href="/"
															className={classes.footerLink}
															color="primary"
															target="_blank"
														>
															Get directions
														</Link>
													</Box>
												</Box>
											</Grid>
										)}

										{showPhone && (
											<Grid item xs={12}>
												<Box display={"flex"} style={{ gap: 12 }}>
													<CallIcon />
													<Box
														display={"flex"}
														flexDirection={"column"}
														style={{ gap: 4 }}
													>
														<Link
															href="tel:32482834828"
															className={classes.footerLink}
															color="secondary"
															target="_blank"
														>
															(832) 775-9938
														</Link>

														<Link
															href="/"
															className={classes.footerLink}
															color="primary"
															target="_blank"
														>
															Tap to call
														</Link>
													</Box>
												</Box>
											</Grid>
										)}

										{showEmail && (
											<Grid item xs={12}>
												<Box display={"flex"} style={{ gap: 12 }}>
													<MailOutlineIcon />
													<Box
														display={"flex"}
														flexDirection={"column"}
														style={{ gap: 4 }}
													>
														<Link
															href="mailto:a@a.com"
															className={classes.footerLink}
															color="secondary"
															target="_blank"
														>
															yae@textgd.com
														</Link>

														<Link
															href="/"
															className={classes.footerLink}
															color="primary"
															target="_blank"
														>
															Email us
														</Link>
													</Box>
												</Box>
											</Grid>
										)}
									</Grid>
								</Grid>
							)}

							<Grid item xs={12} sm={6} md={3}>
								<Grid container spacing={4}>
									<Grid item xs={12}>
										<Box fontSize={20} fontWeight={600}>
											Hours
										</Box>
									</Grid>
									<Grid item xs={12}>
										<Box display={"flex"} justifyContent={"space-between"}>
											<Box
												display={"flex"}
												flexDirection={"column"}
												width={110}
											>
												{daysOfWeek.map((day, index) => (
													<div
														key={`day-${index}`}
														className={classes.hoursDialogDay}
													>
														{index === 0 ? <strong>{day}</strong> : day}
													</div>
												))}
											</Box>
											<Box
												display={"flex"}
												flexGrow={1}
												justifyContent={"space-between"}
											>
												<Box
													display={"flex"}
													flexDirection={"column"}
													width={175}
												>
													{hourSlots.map((hour, index) => (
														<div
															key={`hours-${index}`}
															className={classes.hoursDialogTime}
														>
															{index === 0 ? (
																<strong>
																	<div
																		dangerouslySetInnerHTML={{ __html: hour }}
																	/>
																</strong>
															) : (
																<div
																	dangerouslySetInnerHTML={{ __html: hour }}
																/>
															)}
														</div>
													))}
												</Box>
											</Box>
										</Box>
									</Grid>
								</Grid>
							</Grid>

							<Grid item xs={12} sm={6} md={2}>
								<Grid container spacing={4}>
									<Grid item xs={12}>
										<Box fontSize={20} fontWeight={600}>
											Links
										</Box>
									</Grid>
									{links.map((link, index) => (
										<Grid item xs={12} key={shortid.generate()}>
											<Box fontSize={16} fontWeight={600}>
												<Link
													color="primary"
													underline="hover"
													href={link.link}
													className={classes.footerLink}
												>
													{link.item}
												</Link>
											</Box>
										</Grid>
									))}
								</Grid>
							</Grid>
						</Grid>
					</Container>
				</Box>
			</Box>

			<Box bgcolor="grey.100">
				<Box mx={6}>
					<Container maxWidth="lg" disableGutters>
						<Box
							component="div"
							borderTop={"1px solid rgb(221, 221, 221)"}
							pb={25}
							pt={6}
						>
							<Box
								display="flex"
								justifyContent="space-between"
								alignItems="center"
								flexDirection={{ xs: "column", sm: "row" }}
							>
								<div>
									<Box
										display={"flex"}
										alignItems={"center"}
										flexWrap={"wrap"}
										lineHeight={1.6}
										color={"grey.600"}
									>
										<Box color={"inherit"} underline="hover">
											&copy; {new Date().getFullYear()} Small Fish Big Fish Swim
											School
										</Box>
										<Box
											color={"inherit"}
											underline="hover"
											component="span"
											ml={2}
											mr={2}
										>
											&bull;
										</Box>

										<Link
											color={"inherit"}
											underline="hover"
											href="/terms-of-service"
											target="_blank"
										>
											Terms of Use
										</Link>
										<Box
											color={"inherit"}
											underline="hover"
											component="span"
											ml={2}
											mr={2}
										>
											&bull;
										</Box>

										<Link
											color={"inherit"}
											underline="hover"
											href="/privacy-policy"
											target="_blank"
										>
											Privacy Policy
										</Link>
										<Box
											color={"inherit"}
											underline="hover"
											component="span"
											ml={2}
											mr={2}
										>
											&bull;
										</Box>

										<Link
											color={"inherit"}
											underline="hover"
											href="/accessibility"
											target="_blank"
										>
											Accessibility
										</Link>
									</Box>
									<Box
										fontSize={12}
										lineHeight={1.5}
										mt={2}
										color={"grey.500"}
										maxWidth={800}
									>
										The information on this website is for general information
										purposes only.{" "}
										{legal &&
											"Nothing on this site should be taken as legal advice for any individual case or situation. This information is not intended to create, and receipt or viewing does not constitute, an attorney-client relationship."}
									</Box>
								</div>
								<Box
									display={"flex"}
									alignItems={"center"}
									mt={{ xs: 10, sm: 0 }}
								>
									<a
										href={`http://${SITE_NAME}.com/pro?utm_source=website&utm_medium=website&utm_content=website&utm_campaign=website`}
										target="_blank"
										onMouseEnter={handleMouseEnter}
										onMouseLeave={handleMouseLeave}
									>
										<Box
											fontSize={14}
											lineHeight={1.5}
											mb={2}
											color={isHovered ? "#222" : "grey.700"}
										>
											Powered by
										</Box>
										<Logo
											width={"160px"}
											height={"auto"}
											className={classes.greyHover}
											filter={isHovered ? "" : "grayscale(100%) opacity(0.6)"}
										/>
									</a>
								</Box>
							</Box>
						</Box>
					</Container>
				</Box>
			</Box>
		</React.Fragment>
	);
};

export default WebsiteFooter;
